import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { Card } from "../components/ui/card";

export default function Tags() {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState("#8F8F8F");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchTags = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/tags`, { withCredentials: true });
      setTags(data);
    } catch (e) {
      toast.error("Etiketler alınamadı.");
    }
  }, [BACKEND_URL]);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await axios.post(`${BACKEND_URL}/api/tags`, { name, color }, { withCredentials: true });
      toast.success("Etiket oluşturuldu.");
      setName("");
      fetchTags();
    } catch (e) {
      toast.error("Oluşturulamadı.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/tags/${id}`, { withCredentials: true });
      toast.success("Etiket silindi.");
      fetchTags();
    } catch (e) {
      toast.error("Silinemedi.");
    }
  };

  return (
    <div className="space-y-8 max-w-4xl">
      <div className="flex items-center justify-between border-b border-border pb-4">
        <h1 className="text-3xl font-heading font-bold">Etiketler</h1>
      </div>

      <Card className="swiss-card p-6">
        <form onSubmit={handleCreate} className="flex gap-4 items-end flex-wrap">
          <div className="flex-1 min-w-[200px] space-y-2">
            <Label htmlFor="tag-name">Etiket Adı</Label>
            <Input
              id="tag-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Örn: Maaş, Kira"
              data-testid="tag-name-input"
            />
          </div>
          <div className="w-24 space-y-2">
            <Label htmlFor="tag-color">Renk</Label>
            <Input
              id="tag-color"
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              className="h-10 px-1 py-1"
              data-testid="tag-color-input"
            />
          </div>
          <Button type="submit" data-testid="create-tag-button">
            <Plus size={16} className="mr-2" /> Ekle
          </Button>
        </form>
      </Card>

      <div className="flex flex-wrap gap-4">
        {tags.map(tag => (
          <Card key={tag.id} className="swiss-card flex items-center justify-between px-4 py-2 gap-4">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: tag.color }}></div>
              <span className="font-medium text-sm" data-testid={`tag-name-${tag.id}`}>{tag.name}</span>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 text-destructive hover:bg-destructive/10"
              onClick={() => {
                toast("Emin misiniz?", {
                  action: {
                    label: "Evet, Sil",
                    onClick: () => handleDelete(tag.id)
                  }
                });
              }}
              data-testid={`delete-tag-button-${tag.id}`}
            >
              <Trash2 size={14} />
            </Button>
          </Card>
        ))}
        {tags.length === 0 && (
          <div className="text-muted-foreground text-sm w-full">Kayıtlı etiket bulunamadı.</div>
        )}
      </div>
    </div>
  );
}
